import { Link } from 'react-router-dom';

export function NotFoundPage() {
    return (
        <div className="text-center py-16">
            <div className="text-6xl font-semibold text-ink-faint tracking-tighter tabular-nums">404</div>
            <h1 className="text-lg font-semibold text-ink mt-4">Page not found</h1>
            <p className="text-sm text-ink-subtle mt-2">The page you're looking for doesn't exist.</p>
            <Link to="/" className="btn-secondary mt-6 inline-flex">
                Back to dashboard
            </Link>
        </div>
    );
}
